import { Button } from "components";
import "./offline-notice.scss";

interface OfflineNoticeProps {
  message: string;
  stats: {
    lastSyncTime: Date | null;
  };
}

const OfflineNotice = ({ message, stats }: OfflineNoticeProps) => {
  return (
    <div className="offline-notice">
      <div className="offline-notice__container">
        <div className="offline-notice__icon">📱</div>
        <h2 className="offline-notice__title">Brak danych offline</h2>
        <p className="offline-notice__description">{message}</p>
        <div className="offline-notice__stats">
          {stats.lastSyncTime && (
            <p>
              🕒 Ostatnia synchronizacja: {stats.lastSyncTime.toLocaleString()}
            </p>
          )}
        </div>
        <div className="offline-notice__actions">
          <Button
            onClick={() => window.location.reload()}
            label="Sprawdź połączenie"
          />
        </div>
      </div>
    </div>
  );
};

export default OfflineNotice;
